<template>
  <div style="display: flex;flex-direction: column;">
   <div v-if="item.goods_code" class="goods-item" :class="{ 'has-tax': hasTaxRate }" @mouseenter="markEnter" @mouseleave="markLeave">
      <el-link type="primary" class="stock-box" v-if="showShopStock">{{ $t('constant.inventory') }}{{ item.act_stock }}/{{
        defaultNum(item) }}
      </el-link>
      <el-row align="middle" justify="center" class="img-box">
        <el-image :src="item.logo_url" preview-teleported hide-on-click-modal fit="cover" lazy
          style="width: 64px; height: 64px" :preview-src-list="[item.logo_url]" :z-index="999999">
        </el-image>
      </el-row>
      <div class="name">{{ item.goods_name }}</div>
      <div class="retail_price" v-if="item.goods_price">
        <!--有策略价显示策略价-->
        <span>{{ getCurrencyCodeText() }}{{ np_divide(item.goods_price || 0).toFixed(2) }}</span>
      </div>
      <el-row align="middle" justify="start" class="retail_price"
        v-else-if="item.preferential_price && item.preferential_price < item.retail_price">
        <!--有优惠价显示优惠价-->
        <el-link type="danger">
          {{ getCurrencyCodeText() }}{{ np_divide(item.preferential_price || 0).toFixed(2) }}
        </el-link>
        <div style="text-decoration: line-through; padding-left: 8px">
          <span v-if="item.goods_price">{{ getCurrencyCodeText() }}{{ np_divide(item.goods_price || 0).toFixed(2) }}</span>
          <span v-else>{{ getCurrencyCodeText() }}{{ np_divide(item.retail_price || 0).toFixed(2) }}</span>
        </div>
      </el-row>
      <div class="retail_price" v-else>{{ getCurrencyCodeText() }}{{ np_divide(item.retail_price || 0).toFixed(2) }}</div>

      <!-- 商品消费税率（有 tax_rate 字段才展示） -->
      <div class="tax-rate" v-if="item.tax_rate !== undefined && item.tax_rate !== null && item.tax_rate !== ''">
        {{ $t('productModules.goodsTax.consumptionTax') }} {{ Number(item.tax_rate).toFixed(2) }}%
      </div>

      <template v-if="isMark && !isDetail">
        <img src="@/assets/images/reject.png" class="delete-icon" @click.stop="deleteClick" alt="" />
      </template>
      <div class="mark-box" v-if="isEdit && isMark && !isDetail">
        <el-button type="primary" class="btn" @click.stop="editClick">
          {{ $t('common.edit') }} </el-button>
        <el-button type="primary" class="btn" @click.stop="replaceClick" v-if="isEdit && isReplace">
          {{ $t('constant.replace') }} </el-button>
      </div>
    </div>
    <div v-else class="goods-item empty-box" @click="addClick">
      <img src="@/assets/images/put_add.png" alt="" style="width: 30px; height: 30px" />
      <!-- 删除扩展货道 -->
      <img
        v-if="isLastExpandSlot && !isDetail"
        src="@/assets/images/reject.png"
        class="delete-slot-icon"
        @click.stop="deleteSlotClick"
        alt=""
      />
    </div>
    <div style="width: 200px;height: 30px;color: red;font-size: 14px;" v-if="disabledList.includes(item.sensor)">{{ $t('storeModules.store.disabledTips') }}</div>
    <div v-else style="width: 200px;height: 30px; "></div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { np_divide, getCurrencyCodeText } from '@/utils/tools'
import { $t } from '@/i18n'

const props = defineProps({
  item: {
    type: Object,
    default: {}
  },
  isEdit: {
    type: Boolean,
    default: true
  },
  isDetail: {
    type: Boolean,
    default: false
  },
  isReplace: {
    type: Boolean,
    default: true
  },
  showShopStock: {
    type: Boolean,
    default: false
  },
  disabledList: {
    type: Array,
    default: []
  },
  isLastExpandSlot: {
    type: Boolean,
    default: false
  },
  tallyRecommend: {
    type: Number,
    default: 0
  }
})
const emits = defineEmits([
    'addClick',
    'editClick',
    'deleteClick',
    'replaceClick',
    'deleteSlotClick'
  ]),
  isMark = ref(false)

// 是否展示税率（用于放宽卡片高度，避免名称被遮挡）
const hasTaxRate = computed(
  () =>
    props.item &&
    props.item.tax_rate !== undefined &&
    props.item.tax_rate !== null &&
    props.item.tax_rate !== ''
)

// 鼠标移入
function markEnter() {
  isMark.value = true
}

// 鼠标移出
function markLeave() {
  isMark.value = false
}

// 添加商品
function addClick() {
  if (props.isDetail) {
    return
  }
  emits('addClick', props.item)
}

// 修改商品
function editClick() {
  console.log('====>', props.item)
  emits('editClick', props.item)
}

// 删除商品
function deleteClick() {
  emits('deleteClick', props.item)
}

// 替换商品
function replaceClick() {
  emits('replaceClick', props.item)
}

// 删除扩展货道
function deleteSlotClick() {
  emits('deleteSlotClick', props.item)
}

// 计算建议补货数量
function defaultNum(item) {
  console.log('props.tallyRecommend', props.tallyRecommend)
  if (item) {
    if (props.tallyRecommend === 2) {
      return Math.max(0, (item.std_stock || 0) - (item.act_stock || 0))
    } else {
      return item.std_stock || 0
    }
  }
  return 0
}
</script>

<style lang="scss" scoped>
.goods-item {
  width: 166px;
  height: 130px;
  background: #f6f7fa;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 0 14px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;

  .stock-box {
    position: absolute;
    top: 8px;
    left: 8px;
    font-weight: 500;
    font-size: 13px;
    color: var(--primary-color);
    line-height: 15px;
  }

  .delete-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 22px;
    height: 22px;
    cursor: pointer;
    z-index: 9;
  }

  .img-box {
    width: 80px;
    height: 80px;
    border-radius: 7px;
    margin-top: 10px;
  }

  .name {
    margin: 0px 0 2px;
    font-weight: 600;
    font-size: 14px;
    color: #151515;
    line-height: 20px;
    text-align: left;
    width: 100%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .retail_price {
    font-weight: 800;
    font-size: 14px;
    color: #151515;
    color: var(--primary-color);
    line-height: 16px;
    text-align: left;
    width: 100%;
  }

  .tax-rate {
    font-size: 10px;
    font-weight: 500;
    color: var(--primary-color);
    color: #b4acac;
    line-height: 16px;
    text-align: left;
    width: 100%;
    margin-top: 2px;
  }

  .mark-box {
    position: absolute;
    width: 194px;
    height: 151px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .btn {
      width: 80px;
      height: 36px;

      &:last-child {
        margin-left: 0;
        margin-top: 10px;
      }
    }
  }
}

.empty-box {
  cursor: pointer;
}

.delete-slot-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  z-index: 9;
}
</style>
